export const countryTimezone = {
    "0": {
        "country": "Reino Unido",
        "UTC": "UTC+0"
    },
    "60": {
        "country": "Alemania",
        "UTC": "UTC+1"
    },
    "120": {
        "country": "Sudáfrica",
        "UTC": "UTC+2"
    },
    "180": {
        "country": "Rusia",
        "UTC": "UTC+3"
    },
    "240": {
        "country": "Azerbaiyán",
        "UTC": "UTC+4"
    },
    "300": {
        "country": "Pakistán",
        "UTC": "UTC+5"
    },
    "330": {
        "country": "India",
        "UTC": "UTC+5:30"
    },
    "360": {
        "country": "Bangladés",
        "UTC": "UTC+6"
    },
    "420": {
        "country": "Tailandia",
        "UTC": "UTC+7"
    },
    "480": {
        "country": "China",
        "UTC": "UTC+8"
    },
    "540": {
        "country": "Japón",
        "UTC": "UTC+9"
    },
    "600": {
        "country": "Australia",
        "UTC": "UTC+10"
    },
    "660": {
        "country": "Islas Salomón",
        "UTC": "UTC+11"
    },
    "720": {
        "country": "Fiyi",
        "UTC": "UTC+12"
    },
    "-60": {
        "country": "Portugal",
        "UTC": "UTC-1"
    },
    "-120": {
        "country": "Brasil",
        "UTC": "UTC-2"
    },
    "-180": {
        "country": "Argentina",
        "UTC": "UTC-3"
    },
    "-240": {
        "country": "República Dominicana",
        "UTC": "UTC-4"
    },
    "-300": {
        "country": "Estados Unidos",
        "UTC": "UTC-5"
    },
    "-360": {
        "country": "México",
        "UTC": "UTC-6"
    },
    "-420": {
        "country": "Estados Unidos",
        "UTC": "UTC-7"
    },
    "-480": {
        "country": "Estados Unidos",
        "UTC": "UTC-8"
    },
    "-540": {
        "country": "Alaska",
        "UTC": "UTC-9"
    },
    "-600": {
        "country": "Hawái",
        "UTC": "UTC-10"
    }
}
